module.exports = __webpack_public_path__ + "static/media/yellow_normal_EN.f3eecdb6.png";